import { ThunkResult } from '../../store'
import { replaceResult, replaceResultData } from './PurchaseOrders.slice'
import purchaseOrderItemApi from '../../apis/purchaseOrderItem.api'
import purchaseOrderItemService from '../../services/purchaseOrderItem.service'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search } = getState().purchaseOrders
    const params = { page, limit, search }
    purchaseOrderItemApi.paginate(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}

export function deletePurchaseOrder (id: number): ThunkResult<void> {
  return (dispatch, getState) => {
    purchaseOrderItemApi.delete(id, purchaseOrder => {
      if (!purchaseOrder) return
      const { result } = getState().purchaseOrders
      const data = purchaseOrderItemService.delete(result.data, id)
      dispatch(replaceResultData(data))
    })
  }
}
